import { Box, Button, Link } from '@mui/material'
import LoadingMessage from '@/components/feedbacks/LoadingMessage'
import { legacyUrl } from '@/config'
import { getAuthState } from '@/features/auth/slice'
import { getMediaState } from '@/features/media/slice'
import { useAppSelector } from '@/redux/hooks'

export function WhatsNewPage() {
  const whatsNewHtml = useAppSelector(getMediaState).whatsNewHtml
  const isAdmin = useAppSelector(getAuthState).userRights.isAdmin

  if (whatsNewHtml === '') {
    return <LoadingMessage isQueryMessage={true} />
  }

  return (
    <>
      <Box>
        {/* biome-ignore lint/security/noDangerouslySetInnerHtml: trusted server-rendered CMS content */}
        <Box dangerouslySetInnerHTML={{ __html: whatsNewHtml }} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          padding: '0 16px',
        }}
      >
        {isAdmin && (
          <Button
            variant="contained"
            component={Link}
            href={`${legacyUrl}/WhatsNewAdmin.aspx`}
          >
            Edit Content
          </Button>
        )}
      </Box>
    </>
  )
}
